<template>
  <div style="padding:16px">

    <!-- 头部部分 -->
    <!-- <div ref="search_d">
      <el-row type="flex" class="row-bg" justify="space-around">
        <el-col :span="18">
        </el-col>


        <el-col :span="7">
            <el-form-item label="请输入用户名称:">
            <el-input v-model="queryInfo.condition.memberName" clearable  placeholder="所在城市"></el-input>
          </el-form-item>
          </el-col>
      
        <el-col :span="7">
            <el-form-item label="类型:">
            
              <el-select v-model="queryInfo.condition.noticeType" clearable placeholder="请选择">
                <el-option key="1" label="订单支付成功消息" value="1"></el-option>
                <el-option key="2" label="点赞视频消息" value="2"></el-option>
                <el-option key="3" label="点赞市集消息" value="3"></el-option>
                <el-option key="4" label="收藏视频消息" value="4"></el-option>
                <el-option key="5" label="收藏市集消息" value="5"></el-option>
                <el-option key="6" label="评论视频消息" value="6"></el-option>
                <el-option key="7" label="评论市集消息" value="7"></el-option>
                <el-option key="8" label="审核消息" value="8"></el-option>
                <el-option key="9" label="订单消息" value="9"></el-option>
                <el-option key="10" label="分享通知" value="10"></el-option>
              </el-select>
          
            </el-form-item>
          </el-col>

          <el-button slot="append" icon="el-icon-search" @click="getList"></el-button>
      </el-row>
    </div> -->
    <div ref="search_d">
      <el-form :inline="true" label-width="90px">
        <el-row>
          <el-col :span="7">
            <el-form-item label="用户名称:">
            <el-input v-model="queryInfo.condition.memberName" clearable  placeholder="发布人"></el-input>
          </el-form-item>
          </el-col>
         
          <el-col :span="7">
            <el-form-item label="通知类型:">
            <!-- <el-input v-model="queryInfo.condition.categoryName" clearable  placeholder="所在城市"></el-input> -->
            <el-select v-model="queryInfo.condition.noticeType" clearable placeholder="请选择">
              <el-option key="9" label="订单消息" value="9"></el-option>
              <el-option key="10" label="分享通知" value="10"></el-option>
              <el-option key="1" label="订单支付成功消息" value="1"></el-option>
              <el-option key="2" label="点赞视频消息" value="2"></el-option>
              <el-option key="3" label="点赞市集消息" value="3"></el-option>
              <el-option key="4" label="收藏视频消息" value="4"></el-option>
              <el-option key="5" label="收藏市集消息" value="5"></el-option>
              <el-option key="6" label="评论视频消息" value="6"></el-option>
              <el-option key="7" label="评论市集消息" value="7"></el-option>
              <el-option key="8" label="审核消息" value="8"></el-option>
              
            </el-select>
          
            </el-form-item>
          </el-col>

          <el-button type="primary" :loading="tableLoading" @click="getList">搜索</el-button>
        </el-row>
      </el-form>
    </div>

    <!-- 表格部分 -->
    <div>
      <el-table border ref="table" :data="tableData" tooltip-effect="dark" style="width: 100%" :height="height">
        <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>


          <el-table-column label="用户名称" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.memberName }}</template>
          </el-table-column>
          <el-table-column label="通知类型" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ getNoticeType(scope.row.noticeType) }}</template>
          </el-table-column>
          <el-table-column label="内容" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.content }}</template>
          </el-table-column>
          <el-table-column label="创建时间" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.createDt }}</template>
          </el-table-column>
          <el-table-column label="点赞或收藏人头像" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-avatar shape="square" :size="50" :src="scope.row.logo"></el-avatar>
            </template> 
            <!-- <template slot-scope="scope">{{ scope.row.logo }}</template> -->
          </el-table-column>
          <el-table-column label="点赞或收藏人名称" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.name }}</template>
          </el-table-column>
          <el-table-column label="点赞的视频封面图或市集的首张图" align="center" show-overflow-tooltip>
            <!-- <template slot-scope="scope">{{ scope.row.imgUrl }}</template> -->
            <template slot-scope="scope">
              <el-avatar shape="square" :size="50" :src="scope.row.imgUrl"></el-avatar>
            </template>
          </el-table-column>
        <el-table-column label="操作" width="135" align="center">
          <template slot-scope="scope">
            <!-- <el-button type="text" @click="edit(scope.row)" size="small">编辑</el-button> -->
            <el-popconfirm title="确定删除吗？" @confirm="handleDelte(scope.row.id)">
              <el-button slot="reference" type="text">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="block">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="queryInfo.currPage" :page-sizes="[100, 200, 300, 400]" :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>

    <el-dialog :title="(labelType=='add'?'新增':'编辑')" :visible.sync="showDialog" width="800px">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-row :gutter="10">


            <el-col :span="12">
              <el-form-item label="用户名称：" prop="siteName">
                <el-input v-model="form.memberName" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="1、订单支付成功消息：" prop="siteName">
                <el-input v-model="form.noticeType" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="内容：" prop="siteName">
                <el-input v-model="form.content" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="创建时间：" prop="siteName">
                <el-input v-model="form.createDt" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="点赞或收藏人头像：" prop="siteName">
                <el-input v-model="form.logo" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="点赞或收藏人名称：" prop="siteName">
                <el-input v-model="form.name" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="点赞的视频封面图或市集的首张图：" prop="siteName">
                <el-input v-model="form.imgUrl" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="showDialog = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleSave">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      labelType: 'add',
      rules: {},
      total: 0,
      queryInfo: {
        pageSize: 100,
        pageCount: 1,
        currPage: 1,
        condition: {}
      },
      form: {},
      showDialog: false,
      tableData: [],
      height: window.innerHeight - 256, //表格高度
      headerHeight: 0
    };
  },

  created () {
    this.getList()
  },

  mounted () {
    this.$nextTick(() => {
      // 获取定义ref属性 和 元素高度
      this.headerHeight = this.$refs.search_d.offsetHeight;
      window.addEventListener('resize', this.getHeight())
    })
  },

  methods: {
    // 监听表格高度
    getHeight () {
      this.height = window.innerHeight - this.headerHeight - 256;
    },

    //获取数据
    getList () {
	  var that = this;
	  that.$http.post("/memberNotice/list", that.queryInfo).then(function (response) {
        console.log(response.data.data);
        if (response.data.code == 200) {
          that.total = response.data.data.count;
          that.queryInfo.currPage=response.data.data.currPage
          that.tableData = response.data.data.data;
        }
      });
    },

    // 保存
    handleSave () {
	    var that = this;
	  that.$http.post("/memberNotice/save", that.form).then(function (response) {
		  if (response.data.code == 200) {
			  that.$notify.success({
				title: "提示",
				message: "保存成功",
				showClose: true,
			  });
			 that.showDialog = false
			  that.getList()
		  }else{
			  that.$notify.info({
				title: "提示",
				message: response.data.message,
				showClose: true,
			  });
		  }
      }).catch(function(error){


      })


    },

    //修改
    edit (row) {
      this.showDialog = true;
      this.labelType = 'edit'
      this.form = JSON.parse(JSON.stringify(row))
    },

    // 删除当前行
//    handleDelte (id) {
//      del({ id: id }).then(res => {
//        if (res.code == 200) {
 //         this.$message.success('删除成功')
 //         this.getList()
 //       }
//      })
//    },

	// 删除用户
    async handleDelte(id) {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch((err) => err);
      if (confirmResult === "confirm") {
           var that = this;
        that.$http.post("/memberNotice/delete" ,{"id":id}).then(function (response) {
			if(response.data.code == 200){
			 that.$notify.success({
				title: "提示",
				message: "删除成功",
				showClose: true,
			  });
			  that.getList();
			}else{
				 that.$notify.info({
					title: "提示",
					message: response.data.message,
					showClose: true,
				  });
			}

        });
      }
    },

    //新增按钮
    newBtn () {
      this.labelType = 'add'
      this.showDialog = true;
      this.form = {}
    },

    // 修改页数大小
    handleSizeChange (val) {
      this.queryInfo.pageSize = val;
      this.getList()
    },

    // 获取当前页面
    handleCurrentChange (val) {
      this.queryInfo.currPage = val;
      this.getList()
    },

    getNoticeType(noticeType){
        if(noticeType==='1'){
          return '订单支付成功消息';
        }else if(noticeType==='2'){
          return '点赞视频消息';
        }else if(noticeType==='3'){
          return '点赞市集消息';
        }else if(noticeType==='4'){
          return '收藏视频消息';
        }else if(noticeType==='5'){
          return '收藏市集消息';
        }else if(noticeType==='6'){
          return '评论视频消息';
        }else if(noticeType==='7'){
          return '评论市集消息';
        }else if(noticeType==='8'){
          return '审核消息';
        }else if(noticeType==='9'){
          return '订单消息';
        }else if(noticeType==='10'){
          return '分享通知';
        }
          
    }

  },
};
</script>

<style scoped>
</style>

